<template>
    <div class="tile-content tile-content-secondary">
        <div class="grid-content position-relative">
            <v-inline-loader secondary v-if="isLoading"/>
            <div class="grid-item grid-item-full">
                <p>When the account does not have enough funds you may charge a fee for a particular amount in the currency you desire.</p>
            </div>
            <div class="grid-item grid-item-half" v-if="!isLoading">
                <div class="grid-content">
                    <div class="grid-item grid-item-third">
                        <r-input
                            label="Amount"
                            :value="action.amount"
                            @input="updateAmount"
                            :validate="$v.action.amount"
                            help-text="Must be greater than zero (0)"/>
                    </div>
                    <div class="grid-item">
                        <v-select
                            label="Product Id"
                            :preselect-first="true"
                            :value="action.productId"
                            @input="updateProductId"
                            :options="productsList"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {vSelect} from '@/components/form';
    import {required, decimal, minValue} from 'vuelidate/lib/validators';
    import vInlineLoader from '@/components/v-inline-loader';
    import BaseAction from '../base-action';

    export default {
        name: 'add-nsf-fee',
        extends: BaseAction,
        components: {
            vSelect,
            vInlineLoader,
        },
        data() {
            return {
                isLoading: true,
            };
        },
        validations: {
            action: {
                amount: {
                    required,
                    decimal,
                    minValue: minValue(1),
                },
            },
        },
        computed: {
            productsList() {
                const {products} = this.$store.getters['rulesEngine/products'];
                const list = products.map(product => product.fields.id);
                return list;
            },
        },
        methods: {
            updateProductId(productId) {
                this.$emit('input', this.action.cloneSelf({productId}));
            },
            updateAmount(amount) {
                this.$emit('input', this.action.cloneSelf({amount}));
            },
            getValidationAggregate() {
                return {
                    name: 'add-nsf-fee',
                    rules: [
                        {
                            name: 'NSF Fee amount is required.',
                            delegate: () => {
                                this.$v.$touch();
                                return !this.$v.action.amount.required;
                            },
                        },
                        {
                            name: 'NSF Fee amount must be a valid number.',
                            delegate: () => {
                                this.$v.$touch();
                                return !this.$v.action.amount.decimal;
                            },
                        },
                        {
                            name: 'NSF Fee amount must be greater than 0.',
                            delegate: () => {
                                this.$v.$touch();
                                return !this.$v.action.amount.minValue;
                            },
                        },
                    ],
                };
            },
        },
        created() {
            (async () => {
                await this.$store.dispatch('rulesEngine/fetchProducts');
                this.isLoading = false;
            })();
        },
    };
</script>
